export const MARK_COLOR = 'color';
export const MARK_BG_COLOR = 'backgroundColor';
